import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LogOnMount } from '@mightyhive/analytics';

export function DataSources(): JSX.Element {
  const theme = useTheme();
  return (
    <Box>
      <LogOnMount eventName="Page View: Data Sources" />
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        Data Sources — coming soon
      </Typography>
    </Box>
  );
}
